import cx from 'classnames';
import {Fragment} from 'react';

import {Icon} from 'components';

type Props = {
    open: boolean;
    title?: string;
    onClose?: () => void;
    children: React.ReactElement;
}

export const BottomPopupDialog: React.FC<Props> = ({open, title, onClose, children}) => (
    <Fragment>
        {open && <div className='tw-absolute tw-inset-0 tw-overflow-hidden tw-bg-dark tw-opacity-50 tw-z-1' />}
        <div className={cx(
            'tw-absolute tw-bottom-0 tw-left-0 tw-overflow-hidden',
            'tw-rounded-t-3xl tw-right-0 tw-bg-light tw-z-2',
            {'tw-h-0': !open, 'tw-h-auto': open})}
        >
            {(title || onClose) &&
                <div className='tw-flex tw-m-4'>
                    {title && <div className='tw-ts-h5-bold'>{title}</div>}
                    {onClose && <Icon name='close' className='tw-mr-0' button onClick={onClose} />}
                </div>}
            {children}
        </div>
    </Fragment>

);